<div *ngIf="!loading">
  <div class="spinner"></div>
  <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando solicitação, por favor aguarde ...
  </p>
</div>

<div *ngIf="loading" class="animated fadeIn">

  <!--
  <div class="timeline-body">

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Título da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.tituloProposta }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Identificação do Objeto:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.identificacaoObjeto }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Objetivo Geral da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.objetivoGeralProposta }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Objetivos Específicos da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.objetivoEspecificoProposta }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Justificativa da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.justificativaProposta }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Abrangência da proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.abrangenciaProposta }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Público Beneficiário:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.publicoBeneficiario }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Perfil do Público Beneficiário Direto:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.perfilPublicoBeneficiario }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Meta de Atendimento:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.metaAtendimento }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <div class="col-md-12 no-padding" style="background-color: #0073b7;">
      <div class="col-md-12">
        <label>Período Referência para Execução do Objeto:</label>
      </div>
      <div class="col-md-6">
        <label>Início:</label>
        <input [(ngModel)]="sinteseProposta.dataIniExecucao" type="date" class="form-control" disabled>
      </div>
      <div class="col-md-6">
        <label>Fim:</label>
        <input [(ngModel)]="sinteseProposta.dataFimExecucao" type="date" class="form-control" disabled>
      </div>
      <div class="col-md-12">
        <br>
      </div>
    </div>

    <div class="form-group">
      <p style="color: #ffffff;" >.</p>
    </div>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label> Metodologia e Abordagem da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.metodologiaAbordagemProposta }}</p>
      </mat-card-content>
    </mat-card>


  </div>
-->

  <br>

  <div *ngIf="atualizar == 1">
    <div class="callout callout-info">
      <h4>Não houveram alterações nesta etapa!</h4>
    </div>


    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Título da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.tituloProposta }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Identificação do Objeto:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.identificacaoObjeto }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Objetivo Geral da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.objetivoGeralProposta }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Objetivos Específicos da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.objetivoEspecificoProposta }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Justificativa da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.justificativaProposta }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Abrangência da proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.abrangenciaProposta }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Público Beneficiário:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.publicoBeneficiario }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Perfil do Público Beneficiário Direto:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.perfilPublicoBeneficiario }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Meta de Atendimento:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.metaAtendimento }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <div class="col-md-12 no-padding" style="background-color: #0073b7;">
      <div class="col-md-12">
        <label>Período Referência para Execução do Objeto:</label>
      </div>
      <div class="col-md-6">
        <label>Início:</label>
        <input [(ngModel)]="sinteseProposta.dataIniExecucao" type="date" class="form-control" disabled>
      </div>
      <div class="col-md-6">
        <label>Fim:</label>
        <input [(ngModel)]="sinteseProposta.dataFimExecucao" type="date" class="form-control" disabled>
      </div>
      <div class="col-md-12">
        <br>
      </div>
    </div>

    <div class="form-group">
      <p style="color: #ffffff;">.</p>
    </div>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label> Metodologia e Abordagem da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.metodologiaAbordagemProposta }}</p>
      </mat-card-content>
    </mat-card>
    <br>

    <div class="callout callout-info">
      <h4>Não houveram alterações nesta etapa!</h4>
    </div>
  </div>

  <mat-tab-group *ngIf="atualizar == 0">

    <mat-tab label="Antes">
      <br>
      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Título da Proposta:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sinteseProposta.tituloProposta }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Identificação do Objeto:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sinteseProposta.identificacaoObjeto }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Objetivo Geral da Proposta:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sinteseProposta.objetivoGeralProposta }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Objetivos Específicos da Proposta:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sinteseProposta.objetivoEspecificoProposta }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Justificativa da Proposta:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sinteseProposta.justificativaProposta }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Abrangência da proposta:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sinteseProposta.abrangenciaProposta }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Público Beneficiário:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sinteseProposta.publicoBeneficiario }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Perfil do Público Beneficiário Direto:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sinteseProposta.perfilPublicoBeneficiario }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Meta de Atendimento:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sinteseProposta.metaAtendimento }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <div class="col-md-12 no-padding" style="background-color: #0073b7;">
        <div class="col-md-12">
          <label>Período Referência para Execução do Objeto:</label>
        </div>
        <div class="col-md-6">
          <label>Início:</label>
          <input [(ngModel)]="sinteseProposta.dataIniExecucao" type="date" class="form-control" disabled>
        </div>
        <div class="col-md-6">
          <label>Fim:</label>
          <input [(ngModel)]="sinteseProposta.dataFimExecucao" type="date" class="form-control" disabled>
        </div>
        <div class="col-md-12">
          <br>
        </div>
      </div>

      <div class="form-group">
        <p style="color: #ffffff;">.</p>
      </div>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label> Metodologia e Abordagem da Proposta:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sinteseProposta.metodologiaAbordagemProposta }}</p>
        </mat-card-content>
      </mat-card>
      <br>
    </mat-tab>

    <mat-tab label="Depois">
      <br>
      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Título da Proposta:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sintesePropostaAlterada.tituloProposta }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Identificação do Objeto:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sintesePropostaAlterada.identificacaoObjeto }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Objetivo Geral da Proposta:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sintesePropostaAlterada.objetivoGeralProposta }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Objetivos Específicos da Proposta:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sintesePropostaAlterada.objetivoEspecificoProposta }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Justificativa da Proposta:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sintesePropostaAlterada.justificativaProposta }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Abrangência da proposta:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sintesePropostaAlterada.abrangenciaProposta }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Público Beneficiário:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sintesePropostaAlterada.publicoBeneficiario }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Perfil do Público Beneficiário Direto:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sintesePropostaAlterada.perfilPublicoBeneficiario }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Meta de Atendimento:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sintesePropostaAlterada.metaAtendimento }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <div class="col-md-12 no-padding" style="background-color: #0073b7;">
        <div class="col-md-12">
          <label>Período Referência para Execução do Objeto:</label>
        </div>
        <div class="col-md-6">
          <label>Início:</label>
          <input [(ngModel)]="sintesePropostaAlterada.dataIniExecucao" type="date" class="form-control" disabled>
        </div>
        <div class="col-md-6">
          <label>Fim:</label>
          <input [(ngModel)]="sintesePropostaAlterada.dataFimExecucao" type="date" class="form-control" disabled>
        </div>
        <div class="col-md-12">
          <br>
        </div>
      </div>

      <div class="form-group">
        <p style="color: #ffffff;">.</p>
      </div>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label> Metodologia e Abordagem da Proposta:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ sintesePropostaAlterada.metodologiaAbordagemProposta }}</p>
        </mat-card-content>
      </mat-card>
      <br>

      <div class="callout callout-info">
        <h4>Avaliação da alteração!</h4>
        <div class="ui-g-12 ui-fluid">
          <div class="form-group">
            <div class="radio">
              <label>
                <input type="radio" name="optionsRadios" id="optionsRadios1" (click)="aprovado()">Aprovado
              </label>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <label>
                <input type="radio" name="optionsRadios" id="optionsRadios3" (click)="reprovado()">Reprovado
              </label>
            </div>
          </div>

        </div>

        <textarea [(ngModel)]="alterSinteseProposta.justifAvalAlteracao" class="form-control" rows="3"
          placeholder="Observação ..."></textarea><br>
        <button (click)="finalizarAvaliacao()" type="button" class="btn btn-sm btn-default">AVALIAR</button>
      </div>


    </mat-tab>

  </mat-tab-group>

  <div *ngIf="atualizar == 2">
    <div class="callout callout-info">
      <h4>
        Etapa já avaliada!
        <span style="float: right;"><button (click)="alterarAvaliacao()" type="button"
            class="btn btn-sm btn-default">ALTERAR AVALIAÇÃO</button></span>
      </h4>
    </div>
    
    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Título da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.tituloProposta }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Identificação do Objeto:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.identificacaoObjeto }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Objetivo Geral da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.objetivoGeralProposta }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Objetivos Específicos da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.objetivoEspecificoProposta }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Justificativa da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.justificativaProposta }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Abrangência da proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.abrangenciaProposta }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Público Beneficiário:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.publicoBeneficiario }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Perfil do Público Beneficiário Direto:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.perfilPublicoBeneficiario }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Meta de Atendimento:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.metaAtendimento }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <div class="col-md-12 no-padding" style="background-color: #0073b7;">
      <div class="col-md-12">
        <label>Período Referência para Execução do Objeto:</label>
      </div>
      <div class="col-md-6">
        <label>Início:</label>
        <input [(ngModel)]="sinteseProposta.dataIniExecucao" type="date" class="form-control" disabled>
      </div>
      <div class="col-md-6">
        <label>Fim:</label>
        <input [(ngModel)]="sinteseProposta.dataFimExecucao" type="date" class="form-control" disabled>
      </div>
      <div class="col-md-12">
        <br>
      </div>
    </div>

    <div class="form-group">
      <p style="color: #ffffff;">.</p>
    </div>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label> Metodologia e Abordagem da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ sinteseProposta.metodologiaAbordagemProposta }}</p>
      </mat-card-content>
    </mat-card>



    <br>
    <div class="callout callout-info">
      <h4>
        Etapa já avaliada!
        <span style="float: right;"><button (click)="alterarAvaliacao()" type="button"
            class="btn btn-sm btn-default">ALTERAR AVALIAÇÃO</button></span>
      </h4>
    </div>
  </div>

</div>